import { render, staticRenderFns } from "./GoodsGroup.vue?vue&type=template&id=3ae7b05d&scoped=true&"
import script from "./GoodsGroup.vue?vue&type=script&lang=js&"
export * from "./GoodsGroup.vue?vue&type=script&lang=js&"
import style0 from "./GoodsGroup.vue?vue&type=style&index=0&id=3ae7b05d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae7b05d",
  null
  
)

export default component.exports